import { render, staticRenderFns } from "./FibonacciExtensionSettings.vue?vue&type=template&id=3af431e1&scoped=true"
import script from "./FibonacciExtensionSettings.vue?vue&type=script&lang=js"
export * from "./FibonacciExtensionSettings.vue?vue&type=script&lang=js"
import style0 from "./FibonacciExtensionSettings.vue?vue&type=style&index=0&id=3af431e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af431e1",
  null
  
)

export default component.exports